import assest from '../../json/assest'
import { Box, Button } from '@mui/material'
// import Image from 'next/image'
import React from 'react'



const UserFooter = ({ footerChatBtn }) => {
    const [isActive, setIsActive] = React.useState(false);
    const handleClick = (event) => {
        setIsActive(current => !current);
    };
    return (
        <>
            {
                footerChatBtn &&
                <footer className="userFooter">
                    <Box className={isActive ? 'ftChat open-chat' : 'ftChat'}>
                        <img src={assest.chatFooter} width={38} height={33} alt='chatIcon' onClick={handleClick} />
                        <Button>Share Your Thoughts</Button>
                    </Box>

                </footer>
            }

        </>
    )
}

export default UserFooter